/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {Parcel} from '../../../../core/_models/_parcels-models'
import {useQuery} from 'react-query'
import {FormattedDate, FormattedTime, useIntl} from 'react-intl'
import {getParcelStatuses} from '../../../../core/_requests'
import {useEffect} from 'react'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'

type Props = {
  parcel: Parcel
}

const ParcelStatusCell = ({parcel}: Props) => {
  const intl = useIntl()
  const {ttn, status, type, link} = parcel
  const {data: parcelStatuses} = useQuery(
    ['parcelStatuses', intl.locale, parcel.id],
    () => {
      return getParcelStatuses(parcel.id)
    },
    {keepPreviousData: true, retry: false}
  )
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [parcel.id, parcelStatuses])

  return (
    <div className='text-center'>
      <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
        {parcelStatuses && (
          <div className='d-flex flex-column align-items-center'>
            <div className='d-flex align-items-center gap-2'>
              <div className='d-flex flex-column'>
                <span className='text-dark fw-bold fs-6'>{parcelStatuses.statusLogs[0]?.name}</span>
                {parcelStatuses.statusLogs[0]?.createdAt && (
                  <span className='text-dark fw-bold fs-7'>
                    <FormattedDate
                      year='numeric'
                      month='numeric'
                      day='numeric'
                      value={parcelStatuses.statusLogs[0]?.createdAt}
                    />
                  </span>
                )}
              </div>
              {parcelStatuses.statusLogs && parcelStatuses.statusLogs.length > 1 && (
                <>
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                  >
                    <i className='fas fa-ellipsis-v'></i>
                  </button>
                  <div
                    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-3 mw-300px mw-lg-400px w-100'
                    data-kt-menu='true'
                  >
                    <div className='menu-item px-3'>
                      <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 mb-0 text-center'>
                          <tbody>
                            {parcelStatuses.statusLogs.map((log: any, index: number) => (
                              <tr key={index}>
                                <td>
                                  <span className='text-dark fw-bold fs-6'>{log.name}</span>
                                </td>
                                <td>
                                  <span className='text-dark fw-bold fs-7'>
                                    <FormattedDate
                                      year='numeric'
                                      month='numeric'
                                      day='numeric'
                                      value={log.createdAt}
                                    />{' '}
                                    <FormattedTime value={log.createdAt} />
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {!parcelStatuses && (
          <span className='text-dark fw-bold text-hover-primary d-block fs-6 mb-2'>{status} </span>
        )}
        {ttn && (
          <div className='d-flex justify-content-center align-items-center'>
            {type === 1 && <KTSVG path='/media/icons/np-logo.svg' className=' svg-icon-1 m-1' />}
            {type === 3 && <KTSVG path='/media/icons/vector.svg' className=' svg-icon-1 m-1' />}
            {link ? (
              <a
                target='_blank'
                rel='noreferrer noopener'
                href={link}
                className='text-muted fw-semobold d-block fs-7'
              >
                {' '}
                ТТН {ttn}
              </a>
            ) : (
              <span className='text-muted fw-semobold d-block fs-7'> ТТН {ttn}</span>
            )}
          </div>
        )}
      </span>
    </div>
  )
}

export {ParcelStatusCell}
